import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import { CarIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'
import { OtoIndividualPlacement } from '../../../lib/types/models/enrollment/oto-individual-enrollments'
import { getOtoIndividualTravelInfoDisplay } from '../../../lib/utils/functions/oto-individual.functions'
import { formatPhoneNumber } from '../../../utils/functions/format-phone-number'
import InformationToolTip from '../../elements/information-tooltip'

type Props = {
  placement: OtoIndividualPlacement
  // the provider records the person in charge of the transfer, LEC only reads the state
  onActionClick?: (placement: OtoIndividualPlacement) => void
}

// The accueil-transfert state of a placement, as the backend computes it: grey while the parents
// have not sent their voyage individuel, red while the provider has not recorded the person who
// picks the youth up at the airport, green once it has. A stay without accueil transfert has no
// state. The click bubbles out of the tooltip trigger, so the provider's wrapper opens the edit
// modal on the same click that toggles the tooltip; the provider may record the person at any time.
const OtoIndividualTravelInfoCell = ({ placement, onActionClick }: Props) => {
  const { t } = useTranslate()
  const { travelInfoState, transferPerson } = placement.otoIndividualProposition

  if (!travelInfoState) return '-'

  const { variant, color, label } = getOtoIndividualTravelInfoDisplay(travelInfoState)

  return (
    <InformationToolTip
      contentVariant="secondary"
      icon={
        <Badge
          onClick={(e) => {
            e.stopPropagation()
            if (!onActionClick) return

            onActionClick(placement)
          }}
          icon={<CarIcon color={color} />}
          variant={variant}
          className="h-8"
        />
      }
    >
      <Typography variant="label-medium" color={tailwindColors.black.DEFAULT}>
        {t(label)}
        {transferPerson && (
          <>
            {' — '}
            {toFullName(transferPerson.firstName, transferPerson.lastName, {
              options: { mode: 'lastname-firstname' }
            })}
            {', '}
            {formatPhoneNumber(transferPerson.phoneNumber)}
          </>
        )}
      </Typography>
    </InformationToolTip>
  )
}

export default OtoIndividualTravelInfoCell
